import { render, staticRenderFns } from "./PaymentRegistration.vue?vue&type=template&id=f8a687ca&"
import script from "./PaymentRegistration.vue?vue&type=script&lang=js&"
export * from "./PaymentRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports